import _ from 'lodash'
import React, { PureComponent } from 'react'
import Text from 'react-svg-text'
import { getPhenomenonUrl } from '../helpers'
import classNames from 'classnames'
import { PhenomenonType } from '@futures-platform/ui'
import WaterMarkFP from './WaterMarkFP.svg'
import WaterMarkFPPng from './watermark-fp.png'

export default class Phenomenon extends PureComponent {
    handleDrag = e => {
        // turning off prevent default because it didn't allow phenomena to open on ipad
        // e.preventDefault()
        e.stopPropagation()
        const { onPhenomenaDrag, phenomenon } = this.props
        onPhenomenaDrag(e, phenomenon)
    }

    componentDidMount() {
        const { onPhenomenaDrag } = this.props

        if (onPhenomenaDrag) {
            this.phenomena.addEventListener('mousedown', this.handleDrag)
            this.phenomena.addEventListener('touchstart', this.handleDrag)
            this.phenomena.addEventListener('ontouchstart', this.handleDrag)
        }
    }

    componentWillUnmount() {
        const onPhenomenaDrag = this.props

        if (onPhenomenaDrag) {
            this.phenomena.removeEventListener('mousedown', this.handleDrag)
            this.phenomena.addEventListener('touchstart', this.handleDrag)
            this.phenomena.addEventListener('ontouchstart', this.handleDrag)
        }
    }

    phenomenonRef = ref => {
        this.phenomena = ref
    }

    getPhenomenonType = () => {
        const { phenomenaTypesById, phenomenon: { content: { type: id } } } = this.props

        const defaultValue =  _.find(phenomenaTypesById, type => type.alias === 'undefined')

        return phenomenaTypesById[id] || defaultValue
    }

    getClassNameState = () => {
        const { alias } = this.getPhenomenonType()

        return alias
    }

    includesTag = (tags, filter) => {
        let includes = false

        _.map(tags, tag => {
            if (_.includes(filter, tag)) {
                includes = true
            }
        })

        return includes
    }

    getFilterClassName = () => {
        const { id } = this.getPhenomenonType()
        const { filter, tagFilter, phenomenon: { tags } } = this.props

        if (
            filter
            && filter.length
            && !(_.find(filter, setFilter => setFilter.id === id))
        ) {
            return 'phenomenon-disabled'
        }

        if (
            tagFilter
            && tagFilter.length
            && !this.includesTag(tags, tagFilter)
        ) {
            return 'phenomenon-disabled'
        }

        return null
    }

    getClassNameDrag = (dragged, deleting) => {
        if (dragged && deleting) {
            return 'deleting'
        }

        if (dragged) {
            return 'dragged'
        }

        return ''
    }

    triggeringOpeningContentCardModalHandler = (href, thisElm) => {
        const evt = new CustomEvent("ContentCardOpened", {detail: {href: href, thisElm: thisElm}});
        window.parent.dispatchEvent(evt)
        console.log('dispatched ContentCardOpened event for opening specific card modal for radar sketch for AIF', evt, thisElm)
    }

    render() {
        const {
            deleting,
            labelWidth,
            phenomenaSize,
            cx,
            cy,
            fontSize,
            dragged,
            hidden,
            radarId,
            phenomenon,
            votingOn,
            radarGroupId,
            isAIFCreatePreviewRadar
        } = this.props

        const { content: { title, short_title }, group, halo } = phenomenon

        // todo change to use project URL
        // eslint-disable-next-line
        // const watermarkLink = 'https://go2.futuresplatform.com/sites/all/themes/AltFutures_theme/images/watermark-fp.png?v=2'
        const watermarkLink = WaterMarkFPPng || 'https://go2.futuresplatform.com/sites/default/files/watermark-fp.png'
        // const watermarkLink = 'https://www.google.com/url?sa=i&url=https%3A%2F%2Fwww.bananamoon.com%2Fen%2Fwomen-floral-swimsuit&psig=AOvVaw1cAc5J7Yq6PIr0AQLTFBBH&ust=1668439456742000&source=images&cd=vfe&ved=0CA8QjRxqFwoTCOjpxbq7q_sCFQAAAAAdAAAAABAE'

        let fill
        if (dragged) {
            if (deleting) {
                fill = 'rgba(229, 104, 105, 1)'
            } else {
               fill = 'rgba(43, 201, 143, 0.3)'
            }
        } else if (this.getPhenomenonType().style) {
            fill = this.getPhenomenonType().style.color
        } else {
            fill = 'rgba(43, 201, 143, 1)'
        }

        const radius = phenomenaSize / 2
        const style = {
            fontSize: `${fontSize}px`
        }
        // phenomenon['radarGroupId'] = radarGroupId
        const href = getPhenomenonUrl(radarId, phenomenon)

        const classes = classNames(
            'phenomenon',
            this.getClassNameState(),
            this.getClassNameDrag(dragged, deleting),
            this.getFilterClassName(),
            {
                'content-card left': typeof radarId !== 'undefined',
                hidden
            }
        )

        const isFpGroup = Number(phenomenon?.group) === 0 || (!!phenomenon?.groups?.length && Number(phenomenon?.groups[0]) === 0)
        // document.querySelector("g").addEventListener("click", () => alert("clicked"))
        return (
            <g data-href={href}
               ref={this.phenomenonRef}
               className={!isAIFCreatePreviewRadar && classes}
               data-page="radar-page"
               data-position='left'
               data-groupRadarId={Number(radarGroupId)}
               style={{ cursor: 'pointer' }}
               onClick={() => this.triggeringOpeningContentCardModalHandler(href, this)}
            >
                <PhenomenonType phenomenon={phenomenon}
                                type={this.getPhenomenonType().alias}
                                size={phenomenaSize}
                                x={cx}
                                halo={votingOn && halo}
                                y={cy}
                                fill={fill} 
                                isFpGroup={isFpGroup}
                                isRadarView={true}
                                watermarkLink='https://go2.futuresplatform.com/sites/default/files/watermark-fp.png'
                            />
                { group === 0 && !deleting &&
                    <image
                        x={this.getPhenomenonType()?.alias !== "undefined" ? cx - radius : cx - radius/2}
                        y={this.getPhenomenonType()?.alias !== "undefined" ? cy - radius : cy - radius/2}
                        width={this.getPhenomenonType()?.alias !== "undefined" ? radius * 2 : radius}
                        height={this.getPhenomenonType()?.alias !== "undefined" ? radius * 2 : radius}
                        xlinkHref={this.getPhenomenonType()?.alias !== "undefined" ? watermarkLink : WaterMarkFP}
                    />
                }
                { deleting &&
                    <foreignObject
                        x={cx - radius}
                        y={cy - radius}
                        width={phenomenaSize}
                        height={phenomenaSize}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <div
                            className={'material-icons'}
                            style={{
                                color: 'rgba(255, 255, 255, 0.4)',
                                fontSize: '35px',
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}
                            textAnchor={'middle'}
                        >
                            delete
                        </div>
                    </foreignObject>
                }
                <Text textAnchor={'middle'}
                      verticalAnchor={'start'}
                      x={cx}
                      y={cy + (radius * 1.4)}
                      width={labelWidth}
                      className={'phenomena-label noselect'}
                      style={style}>
                    {short_title || title}
                </Text>
            </g>
        )
    }
}
